export function getName(name) {
    const key = Object.keys(Names).find(k => k.toLowerCase() === name.toLowerCase());
    return key ? Names[key] : name;
}
export const Names = {
    vestibule: { en: 'Vestibule', cs: 'Zádveří' },
    office: { en: 'Office', cs: 'Pracovna' },
    livingRoom: { en: 'Living Room', cs: 'Obývací pokoj' },
    upperHallway: { en: 'Upper Hallway', cs: 'Horní chodba' },
    northRoom: { en: 'North Room', cs: 'Severní pokoj' },
    southRoom: { en: 'South Room', cs: 'Jižní pokoj' },
    bedRoom: { en: 'Bedroom', cs: 'Ložnice' },
};
